import React, { useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"
import { makeStyles } from "@material-ui/core/styles"
import IconButton from "@material-ui/core/IconButton"
import ArrowBackIosOutlinedIcon from "@material-ui/icons/ArrowBackIosOutlined"
import { controlPanelSidebarClose, controlPanelSidebarOpen } from "@/redux/actions/controlPanelSidebarAction"

const useStyles = makeStyles((theme) => ({
    controlPanelSidebarCollapseButton: {
        padding: theme.spacing(1),
        color: "white",
        transform: "rotate(90deg)",
        height: "100%",
        borderRadius: "0",
        [theme.breakpoints.up("md")]: {
            transform: "rotate(0deg)",
        },
        "& .MuiTouchRipple-rippleVisible": {
            top: "0!important",
            height: "100%!important",
        },
    },
    controlPanelSidebarCollapseButtonIcon: {
        transform: ({ closeStatus }) => {
            return closeStatus ? "rotate(180deg)" : ""
        },
    },
}))

const ControlPanelSidebarCollapse = () => {
    const controlPanelSidebarStatus = useSelector((state) => state.controlPanelSidebarReducer)
    const styleProps = {
        closeStatus: !controlPanelSidebarStatus.close,
    }
    const classes = useStyles(styleProps)
    const dispatch = useDispatch()

    const handleSidebarOpen = useCallback(() => {
        if (controlPanelSidebarStatus.close) {
            // open sidebar
            dispatch(controlPanelSidebarOpen())
        } else {
            // close sidebar
            dispatch(controlPanelSidebarClose())
        }
    }, [controlPanelSidebarStatus])

    return (
        <>
            {controlPanelSidebarStatus && (
                <IconButton
                    aria-label="arrow-back"
                    size="small"
                    className={classes.controlPanelSidebarCollapseButton}
                    onClick={handleSidebarOpen}
                >
                    <ArrowBackIosOutlinedIcon fontSize="inherit" className={classes.controlPanelSidebarCollapseButtonIcon} />
                </IconButton>
            )}
        </>
    )
}

export default ControlPanelSidebarCollapse
